module.exports = __webpack_public_path__ + "img/hibob.b6298c23.svg";